var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetherlands01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.65 282.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .nether-1 {\n        fill: #fff;\n      }\n\n      .nether-2 {\n        fill: #b01623;\n      }\n\n      .nether-3 {\n        fill: #1b438c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "nether-2",
    d: "M274.65,94.32H8.01c.05-.13.09-.26.13-.38.14-.4.29-.8.44-1.2C28.39,38.62,80.35,0,141.33,0s112.94,38.62,132.75,92.73c.15.4.29.8.44,1.2.05.12.09.25.13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nether-1",
    d: "M282.65,141.33c0,16.48-2.82,32.3-8.01,47.01H8.01c-5.19-14.7-8.01-30.53-8.01-47.01s2.82-32.3,8.01-47.01h266.64c5.19,14.71,8.01,30.53,8.01,47.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nether-3",
    d: "M274.65,188.33c-.19.53-.38,1.06-.57,1.59-19.81,54.11-71.77,92.73-132.75,92.73S29.43,244.8,9.18,191.54c-.2-.51-.39-1.02-.57-1.53-.2-.55-.4-1.11-.6-1.67h266.64Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlands01);
export default __webpack_public_path__ + "static/media/Netherlands-01.3fbec0052e858c28b955d2c6f45c718b.svg";
export { ForwardRef as ReactComponent };